import BaseComponent from '../../js/base-component';

export default class BannerComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.close= this.refs.close;

        this.onCloseClick = this.onCloseClick.bind(this);
    }


    static getRequiredRefs(){
        return ['close'];
    }

    init(){
        this.close.addEventListener('click', this.onCloseClick);
    }

    onCloseClick(e){
        if(this.element.classList.contains('email-checker')){
            if (document.cookie.indexOf("ct_footer_echecker_banner") < 0) {
                let d = new Date();
                d.setTime(new Date().getTime() + 86400e3 * 365);
                document.cookie = "ct_footer_echecker_banner=1"+"; path=/; expires=" + d.toUTCString();
                this.element.classList.add('hidden');
            }
        }
    }

    onDestroy(){
        this.close.removeEventListener('click', this.onCloseClick);
    }
}
